// extracted by mini-css-extract-plugin
module.exports = {"Subtitle":"styles_Subtitle__3fRZy","SubtitleWithMargin":"styles_SubtitleWithMargin__qebyJ"};